import { CreateNewAppointmentProps } from "./types";
import { BookingWizard } from "./BookingWizard";

export function CreateNewAppointment({
  isOpen,
  onClose,
  loadAppointments,
  mobileNumberProp,
  loadAppointmentCount,
}: CreateNewAppointmentProps) {
  if (!isOpen) return null;

  return (
    <div className="absolute inset-0 bg-white z-20 overflow-auto">
      <BookingWizard
        onClose={onClose}
        loadAppointments={loadAppointments}
        loadAppointmentCount={loadAppointmentCount}
        mobileNumberProp={mobileNumberProp}
      />
    </div>
  );
}
